import { render, staticRenderFns } from "./msThGroup.vue?vue&type=template&id=3fae28e0&scoped=true"
import script from "./msThGroup.vue?vue&type=script&lang=js"
export * from "./msThGroup.vue?vue&type=script&lang=js"
import style0 from "./msThGroup.vue?vue&type=style&index=0&id=3fae28e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fae28e0",
  null
  
)

export default component.exports